<template>
  <div class="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col h-full">
    <div class="relative" v-if="product.images && product.images.length">
      <router-link :to="`/product/${product.id}`">
        <img
          :src="`https://admin.from-malk.com/storage/${product.images[currentImageIndex]}`"
          class="w-full h-48 object-cover object-center rounded-t-lg transition-all duration-300"
        />
      </router-link>

      <!-- Previous Button -->
      <button
        v-if="product.images.length > 1"
        @click.stop="prevImage"
        class="absolute top-1/2 transform -translate-y-1/2 bg-white/70 px-2 py-1 rounded-full shadow start-1"
      >
        <span>{{ $i18n.locale === 'ar' ? '‹' : '‹' }}</span>
      </button>

      <!-- Next Button -->
      <button
        v-if="product.images.length > 1"
        @click.stop="nextImage"
        class="absolute top-1/2 transform -translate-y-1/2 bg-white/70 px-2 py-1 rounded-full shadow end-1"
      >
        <span>{{ $i18n.locale === 'ar' ? '›' : '›' }}</span>
      </button>

      <!-- Discount Badge -->
      <span
        v-if="product.discount"
        class="absolute top-3 left-3 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded"
      >
        -{{ product.discount }}%
      </span>

      <!-- Wishlist -->
      <button
        v-if="isInWishlist !== null"
        @click="$emit('toggle-wishlist', product.id)"
        class="absolute top-3 right-3 p-2 bg-white rounded-full shadow hover:bg-gray-100 transition"
        :class="{ 'text-red-500': isInWishlist }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          :fill="isInWishlist ? 'currentColor' : 'none'"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          />
        </svg>
      </button>
    </div>

    <!-- Product Content -->
    <div class="p-4 flex flex-col justify-between h-full">
      <!-- Top Content -->
      <div>
        <router-link :to="`/product/${product.id}`">
          <h3 class="font-semibold text-gray-800 hover:text-teal-600 mb-1 text-sm">
            {{ product.name.split(' ').slice(0, 6).join(' ') }}<span v-if="product.name.split(' ').length > 6">...</span>
          </h3>
        </router-link>
<div class="flex items-center mb-2 text-xs">
  <div class="flex text-indigo-500">
    <div>{{ $t("productDetails.serviceNo") }}:</div>
  </div>

  <span class="text-gray-500" style="margin-inline-start:0.25rem;">
    {{ product.id }}
  </span>
</div>
        <p class="text-gray-600 text-xs mb-2">
          {{ product.description.substring(0, 80) }}
  <span v-if="product.description.length > 80">...</span>
        </p>

       
      </div>

      <!-- Bottom Section (Always at the bottom) -->
      <div class="flex items-center justify-between mt-3 pt-2 border-t border-gray-100">
        <div>
          <span class="text-lg font-bold text-teal-600 text-sm inline-flex items-center gap-1">
            <img src="/R.svg" alt="SAR" class="w-4 h-4" />
            {{ discountPrice }}
          </span>
          <span
            v-if="product.discount"
            class="text-xs text-gray-500 line-through ml-2 inline-flex items-center gap-1"
          >
            <img src="/R.svg" alt="SAR" class="w-3 h-3" />
            {{ product.price }}
          </span>
        </div>
        <button
          v-if="user && product.user_id !== user.id"
          @click="$emit('open-chat', { userId: product.user_id, product })"
          class="p-2 bg-purple-100 text-purple-600 rounded-full hover:bg-purple-200 transition text-xs"
        >
          💬 Chat
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import useAuth from "@/composables/useAuth";

export default {
  name: "ProductCard",
  props: {
    product: {
      type: Object,
      required: true,
    },
    isInCart: {
      type: Boolean,
      default: null, // null means "not passed"
    },
    isInWishlist: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    const { user } = useAuth();
    return {
      currentImageIndex: 0,
      user,
    };
  },
  computed: {
    discountPrice() {
      if (!this.product.discount) return this.product.price;
      return (this.product.price * (1 - this.product.discount / 100)).toFixed(
        2
      );
    },
    currentImage() {
      // Handle case if product.image is a string (for backward compatibility)
      if (typeof this.product.image === "string") return this.product.image;
      return this.product.image[this.currentImageIndex] || "";
    },
  },
  watch: {
    product() {
      this.currentImageIndex = 0;
    },
  },
  methods: {
    nextImage() {
      this.currentImageIndex =
        (this.currentImageIndex + 1) % this.product.images.length;
    },
    prevImage() {
      this.currentImageIndex =
        (this.currentImageIndex - 1 + this.product.images.length) %
        this.product.images.length;
    },
  },
};
</script>
